exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-organisms-RankingPrepare-___RankingPrepare__container___22h71 {\n  height: 100%;\n  width: 100%;\n  background-color: #50e6a7;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.src-pc-components-organisms-RankingPrepare-___RankingPrepare__l-text___37LpZ {\n  width: 100%;\n  text-align: center;\n  position: relative;\n}\n\n.src-pc-components-organisms-RankingPrepare-___RankingPrepare__subtext___2J5SA {\n  position: absolute;\n  right: 24px;\n  bottom: 24px;\n  font-size: 24px;\n  color: #FFF;\n}\n", ""]);

// exports
exports.locals = {
	"container": "src-pc-components-organisms-RankingPrepare-___RankingPrepare__container___22h71",
	"l-text": "src-pc-components-organisms-RankingPrepare-___RankingPrepare__l-text___37LpZ",
	"subtext": "src-pc-components-organisms-RankingPrepare-___RankingPrepare__subtext___2J5SA"
};